import Pricing from "../components/pages/pricing"

export default Pricing
